import React from "react";
import cx from "./cx";

/**
 * Consejo numerado: «01 · texto» o «01 · título + detalle».
 *  - n: número en mono ('01')
 *  - title: texto principal (.rev-tip-row__t)
 *  - detail: detalle opcional (.rev-help); con detalle se apilan en .rev-paso
 *  - ruled: filete superior que separa la fila de la anterior
 *  - className: aditiva (el molde del esqueleto marca la fila para repartir sus anchos)
 */
const RevTipRow = ({ n, title, detail, ruled, className }) => (
    <div className={cx('rev-tip-row', ruled && 'rev-tip-row--ruled', className)}>
        <span className="rev-mono rev-tip-row__n">{n}</span>
        {detail
            ? <div className="rev-paso">
                <span className="rev-tip-row__t">{title}</span>
                <span className="rev-help">{detail}</span>
            </div>
            : <span className="rev-tip-row__t">{title}</span>}
    </div>
);

export default RevTipRow;
